import React from "react";
import { useIsSafari } from "../../../hooks/useSafari";
import { useSunProgress } from "../../../hooks/useSunProgress";
import { useSunScrollUnlock } from "../../../context/SunScrollContext";
import { SunLayers } from "./SunLayers";
import { SunAnimations } from "./SunAnimations";
import { SunText } from "./SunText";
import { SunHomeProps } from "../../../models/sun-home.model";
import "./SunHome.css";

const SunPage: React.FC<SunHomeProps> = ({ offset, hasAgreed }) => {
	const isSafari = useIsSafari();
	const { unlockScroll } = useSunScrollUnlock();

	// call this once when progress completes
	const onUnlock = () => {
		unlockScroll();
		document.body.style.overflow = "auto";
		document.documentElement.style.overflow = "auto";
	};

	const { progress, textShown } = useSunProgress({
		hasAgreed,
		isSafari,
		onUnlock,
	});

	const transformStyle: React.CSSProperties = {
		transform: `translateY(${-progress * 60}vh)`,
	};

	return (
		<div className="sun-container">
			<SunLayers
				offset={offset}
				transformStyle={transformStyle}
			/>
			{!isSafari && <SunAnimations />}
			{textShown && <SunText onAnimationEnd={onUnlock} />}
		</div>
	);
};

export default SunPage;
